export const BENE_ADDRESS_INFO_DATA = {
  heading: 'Provide recipient details',
  sendingMoneyTo: 'Sending money to',
  description: `We need some details about {NAME} to ensure a smooth and secure transaction.`,
  descriptionAustrac: `As part of regulatory requirements, we now need your recipient's complete address to process your transfer smoothly.
  \n\nPlease provide an address in the destination country you're sending to - you'll only need to do this once.`,
  continueBtn: 'Continue',
  next: 'Next',
  ADDRESS: {
    addresRequired: 'address required',
    description: `Please provide your recipient's full address so we can proceed with your transaction.`,
    goSearch: 'Go back to search',
    searchBtn: 'Search with your postal code',
    enterData: 'Enter address manually',
    searchStreetNumber: 'Search street number'
  },
  DOCUMENTS: {
    documentsRequired: 'information Required',
    description: `Provide your recipient's information to process the transaction`
  },
  saveAndContinue: 'Save and continue'
};
export const ADDRESS_FORM = 'AddressForm';
export const ADDRESS_ARRAY = [
  'address1',
  'address2',
  'postcode',
  'state',
  'town',
  'province',
  'building_number',
  'suburb',
  'district',
  'block_number',
  'building_name',
  'street_name',
  'street_type',
  'street',
  'street_number',
  'unit_number',
  'floor_number',
  'city'
];
